import { useRouter } from 'next/router'
import React from 'react'

import { FormattedMessage } from 'react-intl'

import { DEFAULT_CURRENCY } from '@/lib/constants'
import { Device, OrderEstimate } from '@/lib/types'
import { formatCurrency } from '@/lib/utils'

import RowSkeleton from '@/components/skeletons/RowSkeleton'

export const FundsFlowInfoInstallment = ({
  estimate,
  device,
  isLoading
}: {
  estimate?: OrderEstimate
  device: Device
  isLoading: boolean
}) => {
  const { locale } = useRouter()
  const { currency: deviceCurrency } = device
  const { installmentTerms } = estimate || {}
  const {
    monthlyPayment,
    monthlyPaymentPercentage,
    downPayment,
    downPaymentPercentage,
    paymentCount
  } = installmentTerms || {}

  const currency = deviceCurrency || DEFAULT_CURRENCY

  return (
    <div className="flex flex-col gap-[6px] rounded-md bg-green-100 p-2.5">
      <div className="flex justify-between">
        {isLoading ? (
          <RowSkeleton className="mb-1 h-[18px] w-48" />
        ) : (
          <span className="max-tablet:text-x-sm">
            <FormattedMessage
              {...{
                id: 'dialog.order.installment.down',
                defaultMessage: 'Первоначальный взнос {downPaymentPercentage}%',
                values: { downPaymentPercentage: downPaymentPercentage || 0 }
              }}
            />
          </span>
        )}
        <span className="font-medium">
          {isLoading ? (
            <RowSkeleton className="h-[23px] w-48" />
          ) : (
            formatCurrency(downPayment || 0, currency, locale)
          )}
        </span>
      </div>
      <div className="flex justify-between">
        {isLoading ? (
          <RowSkeleton className="mb-1 h-[18px] w-48" />
        ) : (
          <span className="max-tablet:text-x-sm">
            <FormattedMessage
              {...{
                id: 'dialog.device.order.installment.futurePayments',
                defaultMessage: 'Последующие платежи 5% каждые 30 дней',
                values: {
                  percentage: monthlyPaymentPercentage || 0
                }
              }}
            />
          </span>
        )}
        {isLoading ? (
          <RowSkeleton className="h-[23px] w-48" />
        ) : (
          <span className="flex self-end font-medium max-tablet:text-right">
            <FormattedMessage
              {...{
                id: 'dialog.device.order.installment',
                defaultMessage: '{paymentCount} платежей по {monthlyCount}',
                values: {
                  paymentCount: paymentCount || 0,
                  monthlyCount: formatCurrency(
                    monthlyPayment || 0,
                    currency,
                    locale
                  )
                }
              }}
            />
          </span>
        )}
      </div>
    </div>
  )
}
